import { PRODUCT_SUBCATEGORIES_ITEM_COUNT } from '../constants';

export class DpProductSubcategoriesSwitcherModel {
  readonly #currentIndex: number;
  readonly #totalLists: number;
  readonly #shownFromIndex: number;
  readonly #shownToIndex: number;
  readonly #visibleItemsCount: number;

  constructor(currentIndex = 0, visibleItemsCount = PRODUCT_SUBCATEGORIES_ITEM_COUNT.DESKTOP, totalItems = 0) {
    this.#currentIndex = currentIndex;
    this.#totalLists = totalItems ? Math.ceil(totalItems / visibleItemsCount) : 0;
    this.#shownFromIndex = currentIndex * visibleItemsCount;
    this.#shownToIndex = this.#shownFromIndex + visibleItemsCount;
    this.#visibleItemsCount = visibleItemsCount;
  }

  get currentIndex(): number {
    return this.#currentIndex;
  }

  get totalLists(): number {
    return this.#totalLists;
  }

  get shownFromIndex(): number {
    return this.#shownFromIndex;
  }

  get shownToIndex(): number {
    return this.#shownToIndex;
  }

  get visibleItemsCount(): number {
    return this.#visibleItemsCount;
  }
}
